import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/common/icon_back.png'


import { useUserStore } from '@/stores/user'
import { navToBack } from '@/view/components/supportFunction'
import { useRouter } from 'vue-router'

export default /*@__PURE__*/_defineComponent({
  __name: 'customHeader',
  props: {
    text: {
        type: String,
        default: () => ''
    },
    isShowRightIcon: {
        type: Boolean,
        default: () => false
    },
    isPopupCloseBackIcon: {
        type: Boolean,
        default: () => false
    },
    showHistory: {
        type: Boolean,
        default: () => false
    },
    showFund: {
        type: Boolean,
        default: () => false
    },
},
  emits: ['closePopup', 'openHistoryPopup', 'goToFund'],
  setup(__props, { emit: __emit }) {

const router = useRouter()
const userStore = useUserStore()
const props = __props
const emits = __emit

const handleBackClick = () => {
    navToBack(router, props.isPopupCloseBackIcon, emits)
    userStore.setRechargeBonusType(0)
}


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createBlock(_component_van_row, { class: "header_container" }, {
    default: _withCtx(() => [
      _createVNode(_component_van_col, {
        span: "3",
        class: "header_col"
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "",
            onClick: handleBackClick
          })
        ]),
        _: 1
      }),
      _createVNode(_component_van_col, {
        span: "18",
        class: "header_col"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.text), 1)
        ]),
        _: 1
      }),
      (__props.showHistory)
        ? (_openBlock(), _createBlock(_component_van_col, {
            key: 0,
            span: "3",
            class: "history-col"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                onClick: _cache[0] || (_cache[0] = () => emits('openHistoryPopup'))
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t('common.history')) + " ", 1),
                _createVNode(_component_van_icon, {
                  name: "play",
                  style: {"padding-top":"2px"}
                })
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (__props.showFund)
        ? (_openBlock(), _createBlock(_component_van_col, {
            key: 1,
            span: "3",
            class: "history-col"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                onClick: _cache[1] || (_cache[1] = () => emits('goToFund'))
              }, [
                _createVNode(_component_van_icon, {
                  name: "orders-o",
                  size: "25"
                })
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})